import { render, staticRenderFns } from "./IcreaResume.vue?vue&type=template&id=4cb78ff2&"
import script from "./IcreaResume.vue?vue&type=script&lang=js&"
export * from "./IcreaResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports